var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 481,
    height: 491,
    viewBox: "0 0 481 491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_28",
    x: 61,
    y: 107.35,
    width: 133.001,
    height: 72.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fbdc91"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_27",
    x: 310,
    y: 165.15,
    width: 144,
    height: 72.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fbdc91"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_25",
    x: 19,
    y: 198,
    width: 151,
    height: 73.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fbdc91"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_26",
    x: 272.001,
    y: 85.65,
    width: 196,
    height: 72.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fbdc91"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12164"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.8,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12167"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2461b",
    floodOpacity: 0.8,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12169"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.8,
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12174"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2461b",
    floodOpacity: 0.8,
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12175"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.8,
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12180"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9a3000",
    result: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12181"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9a3000",
    result: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12190"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.8,
    result: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12192"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2461b",
    floodOpacity: 0.8,
    result: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12195"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2461b",
    floodOpacity: 0.8,
    result: "color-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12198"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2461b",
    floodOpacity: 0.8,
    result: "color-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12200"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2461b",
    floodOpacity: 0.8,
    result: "color-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_29"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9a3000",
    result: "color-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12213"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2461b",
    floodOpacity: 0.8,
    result: "color-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12214"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2461b",
    floodOpacity: 0.8,
    result: "color-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12215"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9a3000",
    result: "color-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration-2",
    transform: "translate(-719 -379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19560",
    "data-name": "Group 19560",
    transform: "translate(97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12218",
    "data-name": "Path 12218",
    d: "M30,226H451a30,30,0,0,1,30,30V687a30,30,0,0,1-30,30H30A30,30,0,0,1,0,687V256A30,30,0,0,1,30,226Z",
    transform: "translate(622 153)",
    fill: "#fbdc91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11356",
    "data-name": "Path 11356",
    d: "M0,270.9V30A30,30,0,0,1,30,0H451a30,30,0,0,1,30,30V270.907a288.569,288.569,0,0,1-481,0Z",
    transform: "translate(622 379)",
    fill: "#fff5dc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22669",
    "data-name": "Group 22669",
    transform: "translate(-162 -23.65)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 784, 402.65)",
    filter: "url(#Union_28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_28-2",
    "data-name": "Union 28",
    d: "M-5605.086-1731H-5687a5,5,0,0,1-5-5v-38a5,5,0,0,1,5-5h117a5,5,0,0,1,5,5v38a5,5,0,0,1-5,5h-23.44l4.384,18.7Z",
    transform: "translate(5756 1886.35)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Get_a_virtual_account_number",
    "data-name": "Get a virtual  account number",
    transform: "translate(861 531)",
    fontSize: 13,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Get a virtual "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "account number"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22670",
    "data-name": "Group 22670",
    transform: "translate(935 544.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -313, -165.15)",
    filter: "url(#Union_27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_27-2",
    "data-name": "Union 27",
    d: "M5,66.7a5,5,0,0,1-5-5v-38a5,5,0,0,1,5-5H97.915L113.944,0l-4.383,18.7H133a5,5,0,0,1,5,5v38a5,5,0,0,1-5,5Z",
    transform: "translate(451 231.85) rotate(180)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Send_and_receive_money_in_seconds",
    "data-name": "Send and receive  money in seconds",
    transform: "translate(13 21)",
    fontSize: 13,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Send and receive "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "money in seconds"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22671",
    "data-name": "Group 22671",
    transform: "translate(-189.5 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 811.5, 372)",
    filter: "url(#Union_25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_25-2",
    "data-name": "Union 25",
    d: "M-5588.444-1731H-5687a5,5,0,0,1-5-5v-38a5,5,0,0,1,5-5h135a5,5,0,0,1,5,5v38a5,5,0,0,1-5,5h-24.175l4.618,19.7Z",
    transform: "translate(5714 1977)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Track_and_manage_your_transactions",
    "data-name": "Track and manage  your transactions",
    transform: "translate(846.499 591)",
    fontSize: 13,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Track and manage "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "your transactions"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22672",
    "data-name": "Group 22672",
    transform: "translate(911 464.65)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -289, -85.65)",
    filter: "url(#Union_26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_26-2",
    "data-name": "Union 26",
    d: "M5,66.7a5,5,0,0,1-5-5v-38a5,5,0,0,1,5-5H135.915L151.943,0l-4.383,18.7H185a5,5,0,0,1,5,5v38a5,5,0,0,1-5,5Z",
    transform: "translate(465 152.35) rotate(180)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Earn_reward_points_on_any_transaction_carried_out_",
    "data-name": "Earn reward points on any  transaction carried out ",
    transform: "translate(-1.999 21)",
    fontSize: 13,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Earn reward points on any "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "transaction carried out ")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22667",
    "data-name": "Group 22667",
    transform: "translate(902 478)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12164-2",
    "data-name": "Path 12164",
    d: "M89.033,176.926l-.786,93.911L82.056,338.3l-8.046.221-1.284.036-2.174.059s-1.813-35.038-4.128-49.436c-1.947-12.1.1-33.221.1-33.221l-8.362-61.34c-1.133.131-2.271.231-3.3.3l-7.581,58.789c1.924,3.8,3.7,22.9,3.363,34.285-.226,7.6,2.487,32.612,2.487,32.612-.781.174-1.65.369-2.551.573l-1.264.282-7.509,1.688s-15.172-48.532-18.491-61.841,3.293-85.005,3.293-85.005c6.086-7.154,62.417.619,62.417.619",
    fill: "#6a0dad"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12164-3",
    "data-name": "Path 12164",
    d: "M89.033,176.926l-.786,93.911L82.056,338.3l-8.046.221-1.284.036-2.174.059s-1.813-35.038-4.128-49.436c-1.947-12.1.1-33.221.1-33.221l-8.362-61.34c-1.133.131-2.271.231-3.3.3l-7.581,58.789c1.924,3.8,3.7,22.9,3.363,34.285-.226,7.6,2.487,32.612,2.487,32.612-.781.174-1.65.369-2.551.573l-1.264.282-7.509,1.688s-15.172-48.532-18.491-61.841,3.293-85.005,3.293-85.005c6.086-7.154,62.417.619,62.417.619",
    transform: "translate(183 99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12167-2",
    "data-name": "Path 12167",
    d: "M43.6,324.211,45.628,336.5c3.01,3.823,4.882,2.616,9.318-2.442l-2.455-10.649Z",
    fill: "#ffae77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12167-3",
    "data-name": "Path 12167",
    d: "M43.6,324.211,45.628,336.5c3.01,3.823,4.882,2.616,9.318-2.442l-2.455-10.649Z",
    transform: "translate(183 99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12167-4",
    "data-name": "Path 12167",
    d: "M43.6,324.211,45.628,336.5c3.01,3.823,4.882,2.616,9.318-2.442l-2.455-10.649Z",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12168",
    "data-name": "Path 12168",
    d: "M54.966,318.986a9.973,9.973,0,0,1,.9,6.409,58.332,58.332,0,0,1-14.722,3.11l-1.061-6.59s5.427-1.256,14.884-2.929",
    fill: "#6a0dad"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12169-2",
    "data-name": "Path 12169",
    d: "M57.544,340.246a3.75,3.75,0,0,1,.186.926c-.069,1.447-9.45,14.424-14.474,21.457-2.8,3.922-9.049,3.489-11.86.761a5.639,5.639,0,0,1-1.514-5.4c.37-1.873,2.206-3.736,3-5.585,1.216-2.838,6.287-12.5,6.287-12.5s-.768-5.518,4.217-7.171,7.1,1.75,7.1,1.75c2.557-.061,3.079-3.57,3.38-5.153a43.482,43.482,0,0,1,3.685,10.91",
    fill: "#133248"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12169-3",
    "data-name": "Path 12169",
    d: "M57.544,340.246a3.75,3.75,0,0,1,.186.926c-.069,1.447-9.45,14.424-14.474,21.457-2.8,3.922-9.049,3.489-11.86.761a5.639,5.639,0,0,1-1.514-5.4c.37-1.873,2.206-3.736,3-5.585,1.216-2.838,6.287-12.5,6.287-12.5s-.768-5.518,4.217-7.171,7.1,1.75,7.1,1.75c2.557-.061,3.079-3.57,3.38-5.153a43.482,43.482,0,0,1,3.685,10.91",
    transform: "translate(183 99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12171",
    "data-name": "Path 12171",
    d: "M44.817,346.409a.764.764,0,0,0,.3-1.388,11.77,11.77,0,0,0-5.41-1.949,5.272,5.272,0,0,0-4.737,2.629.765.765,0,1,0,1.362.7,3.763,3.763,0,0,1,3.364-1.795,10.43,10.43,0,0,1,4.567,1.689.76.76,0,0,0,.555.119",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12172",
    "data-name": "Path 12172",
    d: "M45.9,343.467a.764.764,0,0,0,.3-1.388,11.779,11.779,0,0,0-5.41-1.95,5.269,5.269,0,0,0-4.737,2.629.765.765,0,1,0,1.362.7,3.763,3.763,0,0,1,3.365-1.8,10.355,10.355,0,0,1,4.566,1.69.763.763,0,0,0,.556.119",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12173",
    "data-name": "Path 12173",
    d: "M42.825,349.348a.766.766,0,0,0,.3-1.389,11.788,11.788,0,0,0-5.411-1.949,5.267,5.267,0,0,0-4.737,2.629.765.765,0,1,0,1.362.7,3.763,3.763,0,0,1,3.365-1.8,10.359,10.359,0,0,1,4.566,1.689.76.76,0,0,0,.556.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12174-2",
    "data-name": "Path 12174",
    d: "M71.48,343.4l.5,8.865H82.008l.047-9.541Z",
    fill: "#ffae77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12174-3",
    "data-name": "Path 12174",
    d: "M71.48,343.4l.5,8.865H82.008l.047-9.541Z",
    transform: "translate(183 99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12174-4",
    "data-name": "Path 12174",
    d: "M71.48,343.4l.5,8.865H82.008l.047-9.541Z",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12175-2",
    "data-name": "Path 12175",
    d: "M68.14,366.223a3.093,3.093,0,0,1-.938-2.576,18.936,18.936,0,0,1,1.45-6.876v0c.363-2.455,1.509-7.259,3.089-8.794l.173,3.794a8.774,8.774,0,0,1,6.441-2.275,8.177,8.177,0,0,1,3.7,1.332l-.021-3.79a25.637,25.637,0,0,1,2.7,5.519,21.032,21.032,0,0,1,5.529,9.671c.107.44.188.871.246,1.284.781,5.516-20.11,4.205-22.372,2.715",
    fill: "#133248"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12175-3",
    "data-name": "Path 12175",
    d: "M68.14,366.223a3.093,3.093,0,0,1-.938-2.576,18.936,18.936,0,0,1,1.45-6.876v0c.363-2.455,1.509-7.259,3.089-8.794l.173,3.794a8.774,8.774,0,0,1,6.441-2.275,8.177,8.177,0,0,1,3.7,1.332l-.021-3.79a25.637,25.637,0,0,1,2.7,5.519,21.032,21.032,0,0,1,5.529,9.671c.107.44.188.871.246,1.284.781,5.516-20.11,4.205-22.372,2.715",
    transform: "translate(183 99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12177",
    "data-name": "Path 12177",
    d: "M83.23,355.265a.868.868,0,0,0,.342-1.575c-.133-.09-3.285-2.2-6.138-2.225a5.979,5.979,0,0,0-5.383,2.975.868.868,0,1,0,1.545.791,4.27,4.27,0,0,1,3.823-2.03c2.335.02,5.151,1.908,5.179,1.927a.868.868,0,0,0,.632.137",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12178",
    "data-name": "Path 12178",
    d: "M82.781,352.225a.868.868,0,0,0,.342-1.575c-.133-.09-3.285-2.2-6.138-2.225A5.979,5.979,0,0,0,71.6,351.4a.868.868,0,0,0,1.545.791,4.27,4.27,0,0,1,3.823-2.03c2.335.02,5.151,1.908,5.18,1.927a.865.865,0,0,0,.631.137",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12179",
    "data-name": "Path 12179",
    d: "M68.824,337.5l.238,6.181,15.637-.671.371-6.213Z",
    fill: "#6a0dad"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12180-2",
    "data-name": "Path 12180",
    d: "M90.212,80.556c-.261,10.373-5.129,29.319-4.5,44.316.064,1.593.192,3.142.4,4.629.02.178.046.352.072.527.134.889.26,1.8.384,2.72.2,1.5.392,3.039.57,4.6.12,1.063.236,2.14.347,3.224.155,1.536.3,3.088.438,4.639,1.182,13.515,1.564,27.107,1.116,31.711-22.011,20.515-62.124,6.055-62.414-.619-.17-3.923,1.839-15.755,2.533-30.591q.108-2.285.167-4.66c.028-1.1.046-2.214.056-3.339q.016-2.313-.023-4.686c-.023-1.246-.059-2.505-.11-3.769q-.093-2.35-.265-4.729A127.289,127.289,0,0,0,27.454,111.8c-3.345-19.325-13.243-33.555-4.827-37.328S48,63.411,48,63.411H63.241C72.08,67.984,90.5,68.95,90.212,80.556",
    fill: "#ff631c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12180-3",
    "data-name": "Path 12180",
    d: "M90.212,80.556c-.261,10.373-5.129,29.319-4.5,44.316.064,1.593.192,3.142.4,4.629.02.178.046.352.072.527.134.889.26,1.8.384,2.72.2,1.5.392,3.039.57,4.6.12,1.063.236,2.14.347,3.224.155,1.536.3,3.088.438,4.639,1.182,13.515,1.564,27.107,1.116,31.711-22.011,20.515-62.124,6.055-62.414-.619-.17-3.923,1.839-15.755,2.533-30.591q.108-2.285.167-4.66c.028-1.1.046-2.214.056-3.339q.016-2.313-.023-4.686c-.023-1.246-.059-2.505-.11-3.769q-.093-2.35-.265-4.729A127.289,127.289,0,0,0,27.454,111.8c-3.345-19.325-13.243-33.555-4.827-37.328S48,63.411,48,63.411H63.241C72.08,67.984,90.5,68.95,90.212,80.556",
    transform: "translate(183 99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12181-2",
    "data-name": "Path 12181",
    d: "M37.451,71.434s-8.474-5.139-2.634-15.952c4.918-9.106,16.188-6.881,23.956-6.746S77.021,53.09,78.289,62.627s-9.864,8-9.864,8Z",
    fill: "#ff631c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12181-3",
    "data-name": "Path 12181",
    d: "M37.451,71.434s-8.474-5.139-2.634-15.952c4.918-9.106,16.188-6.881,23.956-6.746S77.021,53.09,78.289,62.627s-9.864,8-9.864,8Z",
    transform: "translate(183 99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12182",
    "data-name": "Path 12182",
    d: "M49.586,54.439s-6.656,2.021-7.279,5.479C41.537,64.2,48,65.558,48,65.558l15.241-1.1s3.9.576,4.841-2.367,1.012-10.939-18.5-7.653",
    fill: "#b83b03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12183",
    "data-name": "Path 12183",
    d: "M86.106,129.5a139.455,139.455,0,0,1-25.889,2.258c-6.723,0-13.032-.393-18.5-.925-4.534-.441-8.737-.994-12.477-1.572q-.093-2.35-.265-4.729c3.938.629,8.426,1.235,13.271,1.706,11.971,1.163,28.091,1.641,43.461-1.367.064,1.593.192,3.142.4,4.629",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12184",
    "data-name": "Path 12184",
    d: "M87.131,137.352a136.454,136.454,0,0,1-27.986,2.679c-6.722,0-13.032-.393-18.5-.924-4.054-.4-7.843-.879-11.273-1.39.011-1.541.006-3.106-.023-4.686,3.576.547,7.563,1.069,11.825,1.482,12.472,1.21,29.45,1.678,45.385-1.765.2,1.5.393,3.04.57,4.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12185",
    "data-name": "Path 12185",
    d: "M87.917,145.215a135.535,135.535,0,0,1-28.772,2.849c-6.722,0-13.032-.393-18.5-.925-4.144-.4-8.008-.9-11.5-1.423q.108-2.285.167-4.66c3.586.55,7.583,1.071,11.858,1.487,12.711,1.233,30.1,1.7,46.3-1.967.156,1.536.3,3.087.439,4.639",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12190-2",
    "data-name": "Path 12190",
    d: "M36.162,28.113s-3.7-5.678-3.022-8.128,2.535-1.268,2.535-1.268-2.1-6.254.723-7.437,4.094-.76,4.094-.76,3.673-7.627,8.513-9.148,2.431,2.915,2.431,2.915S60.943-.783,65.126.1s-1.885,4.817-1.885,4.817,5.878-2.662,9.047-2.345-2.662,6.655-2.662,6.655,4.659-.38,6.2,1.521-2.635,4.754-2.635,4.754,2.4,2.218,2.207,3.866a9.484,9.484,0,0,1-.889,2.979s1.808-.194,1.317,1.994-1.58,5.865-1.58,5.865Z",
    fill: "#3b282e"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12190)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12190-3",
    "data-name": "Path 12190",
    d: "M36.162,28.113s-3.7-5.678-3.022-8.128,2.535-1.268,2.535-1.268-2.1-6.254.723-7.437,4.094-.76,4.094-.76,3.673-7.627,8.513-9.148,2.431,2.915,2.431,2.915S60.943-.783,65.126.1s-1.885,4.817-1.885,4.817,5.878-2.662,9.047-2.345-2.662,6.655-2.662,6.655,4.659-.38,6.2,1.521-2.635,4.754-2.635,4.754,2.4,2.218,2.207,3.866a9.484,9.484,0,0,1-.889,2.979s1.808-.194,1.317,1.994-1.58,5.865-1.58,5.865Z",
    transform: "translate(183 99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12191",
    "data-name": "Path 12191",
    d: "M36.134,29.433C36.134,41.016,43.265,49,54.848,49S74.5,40.416,74.5,28.833,67.645,8.474,56.062,8.474c-13.892,0-19.928,9.376-19.928,20.959",
    fill: "#3b282e"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12192-2",
    "data-name": "Path 12192",
    d: "M38.737,31.156s-3.218-4.291-5.611-.743.99,14.028,6.849,11.47Z",
    fill: "#ffae77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12192-3",
    "data-name": "Path 12192",
    d: "M38.737,31.156s-3.218-4.291-5.611-.743.99,14.028,6.849,11.47Z",
    transform: "translate(183 99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12192-4",
    "data-name": "Path 12192",
    d: "M38.737,31.156s-3.218-4.291-5.611-.743.99,14.028,6.849,11.47Z",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12193",
    "data-name": "Path 12193",
    d: "M38.695,38.645a.5.5,0,0,1-.476-.362,7.657,7.657,0,0,0-4.294-4.56.5.5,0,0,1,.351-.926,8.529,8.529,0,0,1,4.9,5.219.5.5,0,0,1-.343.611.52.52,0,0,1-.134.018",
    fill: "#f45339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12194",
    "data-name": "Path 12194",
    d: "M35.312,37.015a.5.5,0,0,1-.416-.763,4.525,4.525,0,0,1,1.858-1.5.495.495,0,0,1,.4.9,3.575,3.575,0,0,0-1.43,1.131.5.5,0,0,1-.417.227",
    fill: "#f45339"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12195-2",
    "data-name": "Path 12195",
    d: "M71.9,31.311s3.218-4.291,5.611-.743-.99,14.028-6.849,11.47Z",
    fill: "#ffae77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12195-3",
    "data-name": "Path 12195",
    d: "M71.9,31.311s3.218-4.291,5.611-.743-.99,14.028-6.849,11.47Z",
    transform: "translate(183 99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12195-4",
    "data-name": "Path 12195",
    d: "M71.9,31.311s3.218-4.291,5.611-.743-.99,14.028-6.849,11.47Z",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12196",
    "data-name": "Path 12196",
    d: "M71.943,38.8a.5.5,0,0,0,.477-.361,7.656,7.656,0,0,1,4.293-4.56.5.5,0,0,0-.351-.926,8.529,8.529,0,0,0-4.9,5.219.5.5,0,0,0,.343.61.48.48,0,0,0,.134.018",
    fill: "#f45339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12197",
    "data-name": "Path 12197",
    d: "M75.327,37.17a.5.5,0,0,0,.416-.764,4.536,4.536,0,0,0-1.858-1.5.495.495,0,0,0-.4.9,3.575,3.575,0,0,1,1.43,1.131.5.5,0,0,0,.417.227",
    fill: "#f45339"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12198-2",
    "data-name": "Path 12198",
    d: "M63.241,54.037V64.459s-3.108,5.307-7.311,5.669S48,65.558,48,65.558V54.77Z",
    fill: "#ffae77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12198-3",
    "data-name": "Path 12198",
    d: "M63.241,54.037V64.459s-3.108,5.307-7.311,5.669S48,65.558,48,65.558V54.77Z",
    transform: "translate(183 99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12198-4",
    "data-name": "Path 12198",
    d: "M63.241,54.037V64.459s-3.108,5.307-7.311,5.669S48,65.558,48,65.558V54.77Z",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12199",
    "data-name": "Path 12199",
    d: "M63.241,54.037v4.624C61.175,62.092,53.6,63.987,48,61.478V54.77Z",
    fill: "#c6723d"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12200-2",
    "data-name": "Path 12200",
    d: "M37.015,34.089a62.76,62.76,0,0,0,.846,6.862c1.4,7.682,7.384,18.657,16.178,19.375,9.48.772,15.993-9.4,18.187-17.079.241-.851.457-1.8.649-2.813.349-1.83.62-3.87.831-5.926.251-2.495.418-5.018.522-7.236a10.844,10.844,0,0,0-6.945-10.643c-6.3-2.419-15.862-4.333-24.927.806a10.874,10.874,0,0,0-5.523,9.258c-.039,2.09-.01,4.642.182,7.4",
    fill: "#ffae77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12200)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12200-3",
    "data-name": "Path 12200",
    d: "M37.015,34.089a62.76,62.76,0,0,0,.846,6.862c1.4,7.682,7.384,18.657,16.178,19.375,9.48.772,15.993-9.4,18.187-17.079.241-.851.457-1.8.649-2.813.349-1.83.62-3.87.831-5.926.251-2.495.418-5.018.522-7.236a10.844,10.844,0,0,0-6.945-10.643c-6.3-2.419-15.862-4.333-24.927.806a10.874,10.874,0,0,0-5.523,9.258c-.039,2.09-.01,4.642.182,7.4",
    transform: "translate(183 99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12200-4",
    "data-name": "Path 12200",
    d: "M37.015,34.089a62.76,62.76,0,0,0,.846,6.862c1.4,7.682,7.384,18.657,16.178,19.375,9.48.772,15.993-9.4,18.187-17.079.241-.851.457-1.8.649-2.813.349-1.83.62-3.87.831-5.926.251-2.495.418-5.018.522-7.236a10.844,10.844,0,0,0-6.945-10.643c-6.3-2.419-15.862-4.333-24.927.806a10.874,10.874,0,0,0-5.523,9.258c-.039,2.09-.01,4.642.182,7.4",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12201",
    "data-name": "Path 12201",
    d: "M61.757,49.554c-.4,2.074-1.738,5.9-6.348,5.928s-5.942-3.44-6.4-5.837Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12202",
    "data-name": "Path 12202",
    d: "M49,39.586c0,1.112-.573,2.014-1.281,2.014s-1.28-.9-1.28-2.014.573-2.014,1.28-2.014S49,38.474,49,39.586",
    fill: "#133248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12203",
    "data-name": "Path 12203",
    d: "M64.522,39.586c0,1.112-.573,2.014-1.281,2.014s-1.28-.9-1.28-2.014.573-2.014,1.28-2.014,1.281.9,1.281,2.014",
    fill: "#133248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12204",
    "data-name": "Path 12204",
    d: "M74.274,34.508h0a2.079,2.079,0,0,1-2.094-2.161c.1-2.031-.093-4.217-1.45-4.627-5.937-1.8.135-4.64-2.545-6.7S64.6,26.543,55.6,26.543c-8.914,0-10.482-6.279-12.3-5.864s-2.3,1.452-1.628,3.764S39.438,29.306,38.95,31.7a5.768,5.768,0,0,0-.094,1.075,1.782,1.782,0,0,1-1.8,1.736c-.225-2.91-.259-5.62-.218-7.816a10.86,10.86,0,0,1,5.606-9.259c9.2-5.139,18.918-3.223,25.312-.8a10.843,10.843,0,0,1,7.054,10.64c-.108,2.219-.275,4.743-.532,7.237",
    transform: "translate(-0.118 -1)",
    fill: "#3b282e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12205",
    "data-name": "Path 12205",
    d: "M43.452,33.042s3.415-1.65,8.688-.177l-.409,2.095a52.533,52.533,0,0,0-8.348.538,3.647,3.647,0,0,1,.069-2.456",
    fill: "#133248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12206",
    "data-name": "Path 12206",
    d: "M67.461,33.042a14.1,14.1,0,0,0-8.688-.177l.41,2.095a52.522,52.522,0,0,1,8.347.538,3.647,3.647,0,0,0-.069-2.456",
    fill: "#133248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12207",
    "data-name": "Path 12207",
    d: "M55.371,47.04h-.017a3.862,3.862,0,0,1-3.229-2.1.606.606,0,0,1,1.085-.54,2.636,2.636,0,0,0,2.15,1.424h.01a2.434,2.434,0,0,0,2.049-1.4.606.606,0,0,1,1.1.5,3.653,3.653,0,0,1-3.153,2.117",
    fill: "#ff7f4d"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_29-2",
    "data-name": "Union 29",
    d: "M-12315.818-2194.751c-14.479-1.508-9.641-16.411-8.434-19.6a.028.028,0,0,1,.008-.02l0-.005c3.8-24.991,18.649-56.627,18.649-56.627,7.729,13.212,6.741,31.29,6.741,31.29l-9.892,26.4-.659,1.752-.07.2c1.051.188,2,.325,2.781.388a72.342,72.342,0,0,1,13.036,2.535l1.5,6.255s-6.229,7.644-19.727,7.643A37.971,37.971,0,0,1-12315.818-2194.751Z",
    transform: "translate(12326 2347.197)",
    fill: "#ff631c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Union_29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_29-3",
    "data-name": "Union 29",
    d: "M-12315.818-2194.751c-14.479-1.508-9.641-16.411-8.434-19.6a.028.028,0,0,1,.008-.02l0-.005c3.8-24.991,18.649-56.627,18.649-56.627,7.729,13.212,6.741,31.29,6.741,31.29l-9.892,26.4-.659,1.752-.07.2c1.051.188,2,.325,2.781.388a72.342,72.342,0,0,1,13.036,2.535l1.5,6.255s-6.229,7.644-19.727,7.643A37.971,37.971,0,0,1-12315.818-2194.751Z",
    transform: "translate(12509 2446.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_29-4",
    "data-name": "Union 29",
    d: "M-12315.818-2194.751c-14.479-1.508-9.641-16.411-8.434-19.6a.028.028,0,0,1,.008-.02l0-.005c3.8-24.991,18.649-56.627,18.649-56.627,7.729,13.212,6.741,31.29,6.741,31.29l-9.892,26.4-.659,1.752-.07.2c1.051.188,2,.325,2.781.388a72.342,72.342,0,0,1,13.036,2.535l1.5,6.255s-6.229,7.644-19.727,7.643A37.971,37.971,0,0,1-12315.818-2194.751Z",
    transform: "translate(12326 2347.197)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12211",
    "data-name": "Path 12211",
    d: "M47.937,145.468l-9.931-.193a1.928,1.928,0,0,1-1.845-1.506l-4.08-15.986c-.277-1.235.875-3.778,2.139-3.73l18.389.694c1.24.046,2.03,2.6,1.706,3.8l-4.478,15.494a1.93,1.93,0,0,1-1.9,1.425",
    fill: "#335464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12212",
    "data-name": "Path 12212",
    d: "M47.8,147.146l-9.931-.193a1.928,1.928,0,0,1-1.845-1.506l-3.9-17.366a1.929,1.929,0,0,1,1.954-2.35l18.389.694a1.928,1.928,0,0,1,1.79,2.431l-4.562,16.865a1.928,1.928,0,0,1-1.9,1.425",
    fill: "#133248"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12213-2",
    "data-name": "Path 12213",
    d: "M33.646,137.7c.8.012,5.412-1.539,4.438-2.806-.789-1.028-4.641-.93-4.641-.93s-.106-.6-.257-1.145l-.127-.569-.682-3.311a2.229,2.229,0,0,0-1.483,1.228c-.76,1.6.064,4.593.064,4.593s-4.2,1.4-3.75,3.116a2.324,2.324,0,0,0,2.41,1.569s-1.836,1.335-.918,2.677,2.937.47,2.937.47-1.821,2.409-.823,3.283a3.124,3.124,0,0,0,2.415.6s-1.352,1.731.471,2.545,4.211-.435,5.595-1.27.681-1.939-3.5-1.6c0,0,4.191-1.6,4.423-2.353.556-1.8-3.317-2.424-5.736-2.237,1.876-.267,6.534-.984,6.023-2.8-.431-1.529-6.055-1.05-6.859-1.062",
    fill: "#ffae77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12213-3",
    "data-name": "Path 12213",
    d: "M33.646,137.7c.8.012,5.412-1.539,4.438-2.806-.789-1.028-4.641-.93-4.641-.93s-.106-.6-.257-1.145l-.127-.569-.682-3.311a2.229,2.229,0,0,0-1.483,1.228c-.76,1.6.064,4.593.064,4.593s-4.2,1.4-3.75,3.116a2.324,2.324,0,0,0,2.41,1.569s-1.836,1.335-.918,2.677,2.937.47,2.937.47-1.821,2.409-.823,3.283a3.124,3.124,0,0,0,2.415.6s-1.352,1.731.471,2.545,4.211-.435,5.595-1.27.681-1.939-3.5-1.6c0,0,4.191-1.6,4.423-2.353.556-1.8-3.317-2.424-5.736-2.237,1.876-.267,6.534-.984,6.023-2.8-.431-1.529-6.055-1.05-6.859-1.062",
    transform: "translate(183 99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12213-4",
    "data-name": "Path 12213",
    d: "M33.646,137.7c.8.012,5.412-1.539,4.438-2.806-.789-1.028-4.641-.93-4.641-.93s-.106-.6-.257-1.145l-.127-.569-.682-3.311a2.229,2.229,0,0,0-1.483,1.228c-.76,1.6.064,4.593.064,4.593s-4.2,1.4-3.75,3.116a2.324,2.324,0,0,0,2.41,1.569s-1.836,1.335-.918,2.677,2.937.47,2.937.47-1.821,2.409-.823,3.283a3.124,3.124,0,0,0,2.415.6s-1.352,1.731.471,2.545,4.211-.435,5.595-1.27.681-1.939-3.5-1.6c0,0,4.191-1.6,4.423-2.353.556-1.8-3.317-2.424-5.736-2.237,1.876-.267,6.534-.984,6.023-2.8-.431-1.529-6.055-1.05-6.859-1.062",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12214-2",
    "data-name": "Path 12214",
    d: "M89.468,182.67s-4.7-.9-7.014,0,.557,4.839.557,4.839L81.148,190.7s2.955,5.78,6.358,6.807,7.836-8.927,7.836-8.927Z",
    fill: "#ffae77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12214-3",
    "data-name": "Path 12214",
    d: "M89.468,182.67s-4.7-.9-7.014,0,.557,4.839.557,4.839L81.148,190.7s2.955,5.78,6.358,6.807,7.836-8.927,7.836-8.927Z",
    transform: "translate(183 99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12214-4",
    "data-name": "Path 12214",
    d: "M89.468,182.67s-4.7-.9-7.014,0,.557,4.839.557,4.839L81.148,190.7s2.955,5.78,6.358,6.807,7.836-8.927,7.836-8.927Z",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12215-2",
    "data-name": "Path 12215",
    d: "M95.347,188.577c-2.42-.84-4.27-3.09-5.88-5.91,0,0,7.03-12.07,8.32-20.26,2.28-14.58,3.59-24.05,3.59-24.05l-.01-.02-.74-1.51-14.44-29.52s-4.65-17.9,3.09-31.11c0,0,24.71,37.31,26.49,62.92,0,0,2.57,20.95-20.42,49.46",
    fill: "#ff631c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183, -99)",
    filter: "url(#Path_12215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12215-3",
    "data-name": "Path 12215",
    d: "M95.347,188.577c-2.42-.84-4.27-3.09-5.88-5.91,0,0,7.03-12.07,8.32-20.26,2.28-14.58,3.59-24.05,3.59-24.05l-.01-.02-.74-1.51-14.44-29.52s-4.65-17.9,3.09-31.11c0,0,24.71,37.31,26.49,62.92,0,0,2.57,20.95-20.42,49.46",
    transform: "translate(183 99)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.52af8cbd00d6e793275aa12fae4782ff.svg";
export { ForwardRef as ReactComponent };